export default function FormGroup({ children }) {
  return <div className="auth__group">
    {children}
  </div>
}
